import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, CircularProgress, Typography } from '@mui/material';
import { IoMdClose } from "react-icons/io";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export default function StatusDialog(props) {




    return (
        <React.Fragment>

            <Dialog
                open={props.open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle id="alert-dialog-title">
                    <Typography variant='h4'>Status</Typography>
                </DialogTitle>
                <Box sx={{ position: 'absolute', right: 10, top: 10, cursor: 'pointer', fontSize: '22px' }} onClick={() => props.handleClose()}>
                    <IoMdClose />
                </Box>
                <DialogContent sx={{margin:0,paddingBlock:0}}>
                    <Box sx={{ minWidth: 120 ,m:0}}>
                        <FormControl fullWidth size='small'>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={props.data?props.data:"select"}
                                onChange={props.handleChange}
                            >
                                <MenuItem value={"select"}>Select Status</MenuItem>
                                <MenuItem value={'B'}>Backend Config Done</MenuItem>
                                <MenuItem value={'F'}>Frontend Config Done</MenuItem>
                                <MenuItem value={'I'}>Inactive</MenuItem>
                                <MenuItem value={'K'}>Blocked</MenuItem>
                                {/* <MenuItem value={'L'}>Replaced</MenuItem> */}
                                <MenuItem value={'P'}>Code Awaited</MenuItem>
                                {/* <MenuItem value={'R'}>Deactivated & Replaced</MenuItem> */}
                                <MenuItem value={'T'}>To be replaced</MenuItem>
                                <MenuItem value={'U'}>Under Config</MenuItem>
                                <MenuItem value={'V'}>To be Replaced & Deactivated</MenuItem>


                            </Select>
                        </FormControl>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'center' ,mt:2}}>
                    <Button disabled={props.IsLoading} variant='contained' color='secondary' onClick={props.handleSubmit} size='small'>
                        {props.IsLoading?<CircularProgress color='inherit' size="20px"/>:"Save"}
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
